import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import { useEffect } from "react";
import SectionUs2 from "./page_us/Solution-US-2/SectionUs2.js";




const PlafondsMursTendus = () =>{
    useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Toile Acoustique Maroc | Mur & Plafond Tendu – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Toile acoustique tendue au Maroc avec UNIK SYSTEM : amélioration du confort sonore avec design moderne et impression personnalisée pour murs et plafonds."
  );

  setMeta(
    "keywords",
    "toile acoustique maroc, mur acoustique maroc, plafond acoustique toile maroc, traitement acoustique maroc, isolation phonique mur maroc, toile tendue acoustique design, UNIK SYSTEM acoustic toile"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute(
    "href",
    "https://unik-system.com/acoustique-toile-maroc"
  );

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Toile Acoustique Maroc – Design & Confort Sonore | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Solution acoustique design pour murs et plafonds avec performance sonore et esthétique moderne."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/US_ACOUSTIC_2.adc1a6e9a72c3e47e094.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/acoustique-toile-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Toile Acoustique Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Mur et plafond acoustique design pour confort sonore optimal."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/US_ACOUSTIC_2.adc1a6e9a72c3e47e094.webp"
  );

  // ========= SCHEMA (LOCAL BUSINESS + SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste en solutions acoustiques et toiles tendues au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Solutions Acoustiques",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Toile Acoustique Murale"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Plafond Acoustique Tendu"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-acoustic-toile");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-acoustic-toile";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi une toile acoustique ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "C’est une toile tendue qui absorbe le son et améliore le confort acoustique d’un espace."
        }
      },
      {
        "@type": "Question",
        name: "Quels sont les avantages ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Réduction du bruit, design personnalisé, amélioration du confort sonore."
        }
      },
      {
        "@type": "Question",
        name: "Pour quels espaces ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Bureaux, hôtels, restaurants et espaces professionnels."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-acoustic-toile");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-acoustic-toile";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);





  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs2/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;